import { render } from "./EditClientDialog.vue?vue&type=template&id=2bb669c2&scoped=true"
import script from "./EditClientDialog.vue?vue&type=script&lang=js"
export * from "./EditClientDialog.vue?vue&type=script&lang=js"

import "./EditClientDialog.vue?vue&type=style&index=0&id=2bb669c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb669c2"]])

export default __exports__